export default "__VITE_ASSET__DCdCafpg__"